export function accountReducer(state = {}, action){
    switch(action.type){
        case 'exampleAction':
            return Object.assign(
                {}, state, { status: action.payload.message }
            );

        default:
            return state;
    }
}
